export const saveToken = (token, refreshToken, expiresIn = 7) => {
  let expiryTime = new Date().getTime() + expiresIn * 24 * 60 * 60 * 1000;
  try {
    if (token) {
      const parts = token.split('.');
      if (parts.length === 3) {
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const pad = base64.length % 4;
        const paddedBase64 = pad ? base64 + '='.repeat(4 - pad) : base64;
        const payload = JSON.parse(atob(paddedBase64));
        if (payload && payload.exp) {
          expiryTime = payload.exp * 1000;
        }
      }
    }
  } catch (err) {
    console.error('Error parsing JWT exp claim:', err);
  }

  localStorage.setItem('accessToken', JSON.stringify({
    token: token,
    refreshToken: refreshToken,
    expiresAt: expiryTime
  }));
};

export const getToken = () => {
  try {
    const storedData = JSON.parse(localStorage.getItem('accessToken'));
    if (!storedData || !storedData.token || !storedData.expiresAt) {
      return null;
    }
    // We don't remove token if it's expired here, so we can use it to refresh
    return storedData.token;
  } catch (err) {
    return null;
  }
};

export const getRefreshToken = () => {
  try {
    const storedData = JSON.parse(localStorage.getItem('accessToken'));
    if (!storedData || !storedData.refreshToken) {
      return null;
    }
    return storedData.refreshToken;
  } catch (err) {
    return null;
  }
};

export const isTokenExpired = () => {
  try {
    const storedData = JSON.parse(localStorage.getItem('accessToken'));
    if (!storedData || !storedData.expiresAt) return true;
    return new Date().getTime() > storedData.expiresAt;
  } catch {
    return true;
  }
};

export const getRememberedEmail = () => {
  return localStorage.getItem('rememberedEmail') || '';
};

export const setRememberedEmail = (email) => {
  if (email) {
    localStorage.setItem('rememberedEmail', email);
  } else {
    localStorage.removeItem('rememberedEmail');
  }
};

export const decodeToken = (token) => {
  try {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    const paddedBase64 = pad ? base64 + '='.repeat(4 - pad) : base64;
    return JSON.parse(atob(paddedBase64));
  } catch (err) {
    console.error('Error decoding JWT token:', err);
    return null;
  }
};